import React from "react";
import PdfViewer from "../../../components/shared/PdfViewer";
import {reportService} from "../../../services/domain/report/service";

const ProductPdfViewer: React.FC<any> = ({
                                             visible,
                                             onClose,
                                             reportType,
                                             title,
                                             apiParam
                                         }) => {

    const loadPdfData = async () => {
        let response;
        switch (reportType) {
            case 'Products':
                response = await reportService.getProductsPdf({
                    "productIds": apiParam.productIds,
                    "order": "PRODUCT_CODE"
                });
                break;
            case 'ProductMembers':
                response = await reportService.getProductMembersPdf({
                    "productIds": apiParam.productIds,
                    "order": "PRODUCT_CODE",
                    "language": apiParam.language
                });
                break;
            case 'ProductMembersNametags':
                response = await reportService.getProductMembersNametagsPdf({
                    "productIds": apiParam.productIds,
                    "order": "PRODUCT_CODE"
                });
                break;
        }
        return response
    };

    /**
     * Export PDF
     */
    const exportPdf = async (filename: string) => {
        // In production, we would handle different report types here
        switch (reportType) {
            case 'Products': // 全會員證書
                await reportService.exportProductsPdf({
                    "productIds": apiParam.productIds,
                    "order": "PRODUCT_CODE"
                });
                break;
            case 'ProductMembers': // 會員資料
                await reportService.exportProductMembersPdf({
                    "productIds": apiParam.productIds,
                    "order": "PRODUCT_CODE",
                    "language": apiParam.language
                });
                break;
            case 'ProductMembersNametags': // 會員產品列表
                await reportService.exportProductMembersNametagsPdf({
                    "productIds": apiParam.productIds,
                    "order": "PRODUCT_CODE"
                });
                break;
        }
    };

    /**
     * Export Excel
     */
    const exportExcel = async (filename: string) => {
        // In production, we would handle different report types here
        switch (reportType) {
            case 'Products': // 全會員證書
                await reportService.exportProductsExcel({
                    "productIds": apiParam.productIds,
                    "order": "PRODUCT_CODE"
                });
                break;
            case 'ProductMembers': // 會員資料
                await reportService.exportProductMembersExcel({
                    "productIds": apiParam.productIds,
                    "order": "PRODUCT_CODE",
                    "language": apiParam.language
                });
                break;
            case 'ProductMembersNametags': // 會員產品列表
                await reportService.exportProductMembersNametagsExcel({
                    "productIds": apiParam.productIds,
                    "order": "PRODUCT_CODE"
                });
                break;
        }
    };

    return (
        <PdfViewer visible={visible}
                   onClose={onClose}
                   title={title}
                   loadPdfData={loadPdfData}
                   exportPdf={exportPdf}
                   exportExcel={exportExcel}
        />
    );
};

export default ProductPdfViewer;